var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"base-tooltip cursor-pointer d-flex justify-content-center align-items-center",attrs:{"to":{ name: 'banners' },"data-tooltip":_vm.$t('titles.banners')}},[_c('Banner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }